import { useState } from "react";

export const useLatch = (value: any) => {
  const [stored, setStored] = useState(value);
  if (!stored && value) {
    setStored(value);
  }
  return stored;
};
